module.exports = __webpack_public_path__ + "static/img/6.19f7a1b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/6.png
// module id = wT/r
// module chunks = 0